import { Box } from '@chakra-ui/react';
import React from 'react';

interface ArticleCardProps {
  slug: string;
  title: string;
  description: string;
  Icon: React.ComponentType<{ className?: string }>;
  gradient: string;
}

const ArticleCard = ({
  slug,
  title,
  description,
  Icon,
  gradient,
}: ArticleCardProps): React.JSX.Element => {
  return (
    <a href={`/learn-more/${slug}`} className="block">
      <Box
        display="flex"
        flexDirection="column"
        gap={0}
        height="100%"
        className="rounded-3xl bg-white/90 dark:bg-neutral-900/90 shadow-lg ring-1 ring-black/5 dark:ring-white/10 p-6 transition-all duration-200 hover:-translate-y-1 hover:shadow-xl"
      >
        <div className="flex items-center gap-3">
          <div
            className={`h-8 w-8 rounded-full bg-gradient-to-br ${gradient} text-white flex items-center justify-center shadow-sm`}
          >
            <Icon className="h-4 w-4" />
          </div>
          <h3 className="text-lg font-semibold text-neutral-900 dark:text-white">{title}</h3>
        </div>

        <p className="mt-3 text-sm leading-6 text-neutral-600 dark:text-neutral-300">
          {description}
        </p>
      </Box>
    </a>
  );
};

export default ArticleCard;
